import api from '@/api';
import {
  PurchaseSped,
  PurchaseSpedImportRequest,
  PurchaseSpedListRequest,
} from './purchase-sped.types';

const path = '/purchase/v1/purchases/sped';

export default {
  async list(params: PurchaseSpedListRequest) {
    const result = (await api.get(
      `${path}/reduced-purchases`,
      params,
    )) as unknown;
    return result as PurchaseSped[];
  },

  async import(data: PurchaseSpedImportRequest) {
    const result = (await api.post(`${path}/xmls`, data)) as unknown;
    return result as void;
  },
};
